import React, { createContext, useState, useMemo, useEffect } from "react";
import { ThemeProvider, CssBaseline } from '@mui/material';
import { StyledEngineProvider } from '@mui/material/styles';
import { ThemeProvider as JssThemeProvider } from '@mui/styles';
import { darkTheme, lightTheme } from "../theme";

// Create the context for managing the theme
export const ThemeContext = createContext(undefined);

// Get the initial theme mode from localStorage
const getInitialMode = () => {
    const savedMode = localStorage.getItem("themeMode");
    return savedMode === "light" ? "light" : "dark";
};

// The ThemeProviderWrapper component that provides theme context and theme switching logic
export const ThemeProviderWrapper = ({ children }) => {
    const [mode, setMode] = useState(getInitialMode);

    // Store the mode in localStorage whenever it changes
    useEffect(() => {
        localStorage.setItem("themeMode", mode);
    }, [mode]);

    // Memoize the theme based on the current mode
    const currentTheme = useMemo(() => (mode === "light" ? lightTheme : darkTheme), [mode]);

    // Toggle between light and dark themes
    const toggleTheme = () => {
        setMode((prevMode) => (prevMode === "light" ? "dark" : "light"));
    };

    return (
        <ThemeContext.Provider value={{ mode, toggleTheme }}>
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={currentTheme}>
                    <JssThemeProvider theme={currentTheme}>
                        <CssBaseline />
                        {children}
                    </JssThemeProvider>
                </ThemeProvider>
            </StyledEngineProvider>
        </ThemeContext.Provider>
    );
};
